import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  onCancel: () => void
}

export const PrintingModal = ({ onCancel }: Props) => {
  return (
    <Modal.Root onPressOutside={() => {}}>
      <Modal.Header title="Preparing..." />
      <Modal.Content>
        <Text>Please wait while we convert your document for printing.</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={onCancel}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
